module.exports = __webpack_public_path__ + "static/media/房地产行业解决方案.3290103e.png";